<template>
  <b-modal
    v-if="activity"
    id="taskActivityViewModal"
    ref="modal"
    :title="'Activity Details'"
    size="xl"
    hide-footer
  >
    <b-row>
      <!-- Activity Details Table -->
      <b-col
        cols="12"
        class="table-responsive"
      >
        <h5 class="mt-1">
          {{ t('Details') }}
        </h5>
        <table class="table">
          <tr>
            <td class="font-weight-bolder va-baseline">
              {{ t('Activity') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.subject_name || 'N/A' }}
            </td>
            <td class="font-weight-bolder va-baseline">
              {{ t('WMA') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.WMA || 'N/A' }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bolder va-baseline">
              {{ t('Purpose') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.purpose || 'N/A' }}
            </td>
            <td class="font-weight-bolder va-baseline">
              {{ t('Discussion') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.discussion || 'N/A' }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bolder va-baseline">
              {{ t('Outcome') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.outcome || 'N/A' }}
            </td>
            <td class="font-weight-bolder va-baseline">
              {{ t('Start Date & Time') }}
            </td>
            <td class="va-baseline text-justify">
              {{ formatDateTime(activity.start_date_time) }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bolder va-baseline">
              {{ t('Period') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.period_title || 'N/A' }}
            </td>
            <td class="font-weight-bolder va-baseline">
              {{ t('Year') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.year || 'N/A' }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bolder va-baseline">
              {{ t('Amount') }}
            </td>
            <td class="va-baseline text-justify">
              {{ activity.amount || 'N/A' }}
            </td>
            <td class="font-weight-bolder va-baseline" />
            <td class="va-baseline" />
          </tr>
        </table>
      </b-col>

      <!-- Contact Table -->
      <b-col
        cols="12"
        class="table-responsive"
      >
        <h5 class="mt-1">
          {{ t('Contact') }}
        </h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ t('Id') }}</th>
              <th>{{ t('Name') }}</th>
              <th>{{ t('Mobile') }}</th>
              <th>{{ t('Email') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!activity.contact_data || activity.contact_data.length === 0">
              <td
                colspan="4"
                class="text-center"
              >
                {{ t('No Records Found') }}
              </td>
            </tr>
            <tr
              v-for="(cdata, index) in activity.contact_data"
              :key="index"
            >
              <td>{{ cdata.id }}</td>
              <td>{{ cdata.name || 'N/A' }}</td>
              <td>{{ cdata.mobile || 'N/A' }}</td>
              <td>{{ cdata.email || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

  </b-modal>
</template>

<script>
import 'bootstrap-vue'
import { useUtils } from '@/@core/libs/i18n'
import { activityDateFormat } from '@/utils/common'

export default {
  components: {
  },
  props: {
    activity: {
      type: Object,
      default: () => null,
    },
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  mounted() {
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    formatDateTime(date) {
      return activityDateFormat(date)
    },
  },
}
</script>
